<template>
  <div class="analytics">   
     <div class="container-fluid">
        <div class="row">
          <Menu title="Analytics" />

          <div class="col-12 p-0"> 
            <AnalyticsComponent id="analytics_view" 
            :style="{
                width : !$store.state.menu_toggle ? 'calc(100% - 70px)' : 'calc(100% - 255px )',
            }" 
            ></AnalyticsComponent>
          </div>
        </div>
     </div>   
  </div>
</template>

<script>
import Menu from '@/components/menu_component.vue';
import AnalyticsComponent from '@/components/analytics_component.vue';
  
export default {
    name: 'AnalyticView',
    data() {
        return {
        }
    },
    components: {  
      Menu,   
      AnalyticsComponent,
    }
}
</script>